export default {
  DESK:{},
  MOBIL:{},
  TABLET:{},
  defaultStyle: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      maxWidth: '645px',
      marginLeft: 'auto',
      boxShadow: '0 3px 4px 0 rgba(0,0,0,.3)',
      backgroundColor: '#fff',
      '& $childAgesContainer':{
        alignItems: 'center',
        flexDirection: 'row'
      },
    },
    '&:lang(ar)':{
      direction:'rtl',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        marginLeft:0,
        marginRight: 'auto'
      }
    },
    [`@media (max-width: ${data.modalBreak - 1}px)`]:{
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '3px'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888'
      },
      '&::-webkit-scrollbar-track': {
        background: '#fff'
      }
    },
  }),
  roomLine: data => ({
    backgroundColor: '#f6f6f6',
    padding: '10px 0',
    textAlign: 'center',
    border: '1px solid #e1e1e1',
    borderTop: 0,
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '9px 10px 9px 35px',
      textAlign: 'left'
    },
    '&:lang(ar)':{
      [`@media (min-width: ${data.modalBreak}px)`]: {
        padding:'9px 35px 9px 10px'
      }
    }
  }),
  roomContainer: data => ({
    padding: '0 40px',
    display: 'inline-block',
    width: '100%',
    maxWidth: '210px',
    position: 'relative',
    boxSizing: 'content-box',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      display: 'block',
      maxWidth: '156px'
    },
    '& button':{
      '&[disabled]':{
        opacity:'.5',
        cursor:'initial',
        '&:hover':{
          backgroundColor:'#f1f1f1',
          '&:after':{
            backgroundColor: data.mainColor
          },
          '&:before':{
            backgroundColor: data.mainColor
          }
        }
      }
    }
  }),
  deleteRoomContainer:{},
  line: data => ({
    border: '1px solid #e1e1e1',
    borderTop: 0,
    background: '#fff',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      borderLeft: 0,
      borderRight: 0
    }
  }),
  lineContent: data => ({
    padding: '10px 11px 12px',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '15px 0'
    }
  }),
  extraLine: data => ({
    composes: '$line',
    textAlign: 'right',
    padding:'20px 14px 20px',
    border: 'none',
    '&:lang(ar)':{
      textAlign:'left',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        paddingLeft:0
      }
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding:'10px 0 10px 14px',
      '&:lang(ar)':{
        padding: '10px 14px 10px 0',
      }
    }
  }),
  relativeElement: data => ({
    padding: '0 33px',
    margin: '0 auto',
    boxSizing: 'border-box',
    outline: 'none',
    position: 'relative',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      maxWidth:'none'
    },
    '&:first-of-type': {
      marginBottom: '11px',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        marginBottom: 0
      }
    },
    '& button':{
      '&[disabled]':{
        opacity:'.5',
        cursor:'initial',
        '&:hover':{
          backgroundColor:'#f1f1f1',
          '&:after':{
            backgroundColor: data.mainColor
          },
          '&:before':{
            backgroundColor: data.mainColor
          }
        }
      }
    }
  }),
  personSelector: {
    composes: '$relativeElement',
    display: 'block',
    maxWidth: 'none'
  },
  button: data => ({
    height: '28px',
    width: '28px',
    borderWidth: '1px',
    borderStyle: 'solid',
    position: 'absolute',
    left: 0,
    top: '50%',
    marginTop: '-14px !important', /* Important added to fix generic htcmonsterrat styles */
    borderRadius: '50%',
    borderColor: data.mainColor,
    transition: 'all .3s',
    '&:hover': {
      [`@media (min-width: ${data.modalBreak}px)`]: {
        backgroundColor: data.mainColor,
        '&::after': {
          backgroundColor: '#fff'
        }
      }
    },
    '&::after': {
      content: `''`,
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: '12px',
      height: '2px',
      margin: '-1px 0 0 -6px',
      backgroundColor: data.mainColor
    },
    '&:lang(ar)':{
      left:'auto',
      right:0,
      '&::after':{
        left:'auto',
        right:'50%',
        margin:'-1px -6px 0 0'
      }
    }
  }),
  buttonAdd: data => ({
    composes: '$button',
    left: 'auto',
    right: 0,
    '&:hover': {
      [`@media (min-width: ${data.modalBreak}px)`]: {
        backgroundColor: data.mainColor,
        '&:before': {
          backgroundColor: '#fff'
        }
      }
    },
    '&:before': {
      content: `''`,
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: '2px',
      height: '12px',
      margin: '-6px 0 0 -1px',
      backgroundColor: data.mainColor
    },
    '&:lang(ar)':{
      left:'0',
      right:'auto',
      '&:before': {
        left:'auto',
        right:'50%',
        margin:'-6px -1px 0 0'
      }
    }
  }),
  numberBox: data => ({
    backgroundColor: '#fff',
    border: '1px solid rgba(0,0,0,.2)',
    font: '300 13px/1.38 Roboto,sans-serif',
    padding: '11px 5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    color: '#000',
    outline: 'none',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      width: 'auto',
      paddingLeft: '15px'
    },
    '&:lang(ar)':{
      direction: 'rtl',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        paddingLeft: 0,
      }
    }
  }),
  roomNumbers: {
    composes: '$numberBox',
  },
  roomList: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: ' 0 20px',
      maxHeight: '400px',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '3px'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888'
      },
      '&::-webkit-scrollbar-track': {
        background: '#fff'
      }
    }
  }),
  tableLine: data => ({
    display: 'flex',
    alignItems:'flex-start',
    justifyContent:'space-between',
    font: "400 13px 'Roboto', sans-serif",
    [`@media (min-width: ${data.modalBreak}px)`]: {
      alignItems:'center',
    },
    '& $box': {
      textAlign: 'left',
      width:'auto',
      flex:'0 0 45%',
      paddingRight:'10px',
      outline: 'none',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        flex:'0 0 29%',
      },
      '&$deleteRoomContainer':{
        flexBasis:'auto',
        flexGrow:'1',
        textAlign:'right',
        paddingRight:'0',
        '&:lang(ar)':{
          textAlign: 'left',
        }
      },
      '&:lang(ar)':{
        textAlign:'right',
        '&:first-of-type':{
          paddingRight: '0',
          textAlign: 'right',
        }
      },
    },
    '&:lang(ar)':{
      flexDirection: 'row-reverse',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        flexDirection: 'unset',
      }
    }
  }),
  box: data => ({
    display: 'table-cell',
    width: '50%',
    verticalAlign: 'top',
    textAlign: 'right',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      verticalAlign: 'middle',
      textAlign: 'left'
    },
    '&:lang(ar)':{
      textAlign:'left',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        textAlign:'right'
      }
    },
    '&$deleteRoomContainer':{
      flexBasis:'auto',
      flexGrow:'1',
      textAlign:'right',
      paddingRight:'0'
    },
  }),
  occupsEnter: {
    transition: 'max-height 0ms ease-out',
    maxHeight: '0'
  },
  occupsEnterActive: {
    maxHeight: '100px',
    transition: 'max-height 300ms ease-out',
    overflow: 'hidden'
  },
  occupsLeave: {
    maxHeight: '100px',
    transition: 'max-height 300ms ease-out'
  },
  occupsLeaveActive: {
    transition: 'max-height 300ms ease-out',
    maxHeight: '0',
    overflow: 'hidden',
    padding:'0'
  },
  removeRoom: data => ({
    height: '25px',
    width: '25px',
    display: 'inline-block',
    marginTop: '3px',
    textAlign: 'left',
    backgroundColor:'transparent',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      marginTop: 0,
      height: '40px',
      width: '40px',
      textAlign: 'right'
    },
    '&:lang(ar)':{
      textAlign:'right',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        textAlign:'left'
      }
    }
  }),
  removeRoomIcon: data => ({
    fontSize: '18px',
    lineHeight: '25px',
    color: data.mainColor,
    [`@media (min-width: ${data.modalBreak}px)`]: {
      fontSize: '24px'
    }
  }),
  disabled: {
    composes: '$removeRoomIcon',
    color: '#b2b2b2'
  },
  roomListTitle: {
    font: '300 20px/1.2 Roboto,sans-serif',
    wordBreak: 'break-word',
    color: '#000'
  },
  ariaHidden: {
    position: 'absolute',
    width: '0',
    padding: '0',
    margin: '0',
    height: '0',
  },
  occupFooter: data => ({
    padding: '10px 14px 37px',
    backgroundColor: '#fff',
    font: "400 13px 'Roboto', sans-serif",
    textAlign: 'right',
    '& $tableLine':{
      justifyContent:'flex-end',
      '& $box':{
        paddingRight:0,
        font: "400 13px 'Roboto', sans-serif",
      }
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding: '30px 20px 20px'
    },
    '&:lang(ar)':{
      textAlign:'left'
    }
  }),
  confirmButton: {
    width: 'auto',
    height: '40px',
    marginRight: 0,
    marginLeft: 'auto',
    display: 'block',
    minWidth: '120px',
    padding: '5px',
    boxSizing:'border-box',
    fontFamily: 'Roboto, sans-serif',
    '&:lang(ar)':{
      marginLeft:0,
      marginRight:'auto'
    }
  },
  extraText: data => ({
    font: '13px/1.38 Roboto,sans-serif',
    textAlign: 'right',
    color: '#000',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      color: '#666',
      textAlign: 'left'
    },
    '&:lang(ar)':{
      textAlign:'left',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        textAlign:'right'
      }
    }
  }),
  portalDesign: data => ({
    font: "500 16px 'Roboto', sans-serif",
    [`@media (min-width: ${data.modalBreak}px)`]: {
      boxShadow: 'none',
    },
  }),
  customSelectContainer:{
    position: 'relative',
  },
  customSelect:{},
  childAgesContainer:{
    display: 'flex',
    borderTop: '1px solid #e1e1e1',
    marginTop: '15px',
    alignItems: 'flex-start',
    flexDirection: 'column'
  },
  childAgesText:{
    marginTop: '15px',
    minWidth: '120px',
    maxWidth: '240px',
    textAlign: 'left',
  },
  childAgesSelect:{
    marginTop: '15px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    '& $customSelectContainer':{
      '& $customSelect':{
        appearance: 'none',
        width: '110px',
        height: '42px',
        padding: '11px 15px',
        backgroundColor: '#fff',
        border: '1px solid rgba(0,0,0,.2)',
        color: '#000',
        cursor: 'pointer',
        boxSizing: 'border-box',
      },
      '&:after':{
        content: '""',
        position: 'absolute',
        border: 'solid',
        borderWidth: '0 2px 2px 0',
        borderColor: data => data.mainColor,
        transform: 'rotate(45deg)',
        padding: '5px',
        top: '30%',
        left: '75%',
        cursor: 'pointer',
        pointerEvents:'none'
      }
    },
  },
  ageChildsBtn: data => ({
    composes: '$button',
    left: '100px',
    right: 0,
    '&:hover': {
      [`@media (min-width: ${data.modalBreak}px)`]: {
        backgroundColor: data.mainColor,
        '&:before': {
          backgroundColor: '#fff'
        }
      }
    },
    '&:before': {
      top: '50%',
      left: '50%',
      width: '0px',
      height: '1px',
      margin: '-10px 0px 0px -6px',
      content: '""',
      position: 'absolute',
      transform: 'rotate(45deg)',
      border: 'solid',
      borderColor: data.mainColor,
      borderWidth: '0 3px 3px 0',
      padding: '5px'
    },
    '&:after': {
      content: 'unset',
    },
    '&:lang(ar)':{
      left:'0',
      right:'auto',
      '&:before': {
        left:'auto',
        right:'50%',
        margin:'-6px -1px 0 0'
      }
    }
  }),
  roundedTheme:{
    borderRadius: '25px',
    '& $roomLine':{
      borderRadius: '25px 25px 0 0',
      '& $roomContainer':{
        '& $numberBox':{
          borderRadius: '25px'
        }
      }
    },
    '& $roomList':{
      borderRadius: '0 0 25px 25px',
      '& $line':{
        '&$extraLine':{
          borderRadius: ' 0 0 25px 25px'
        },
        '& $lineContent':{
          '& $tableLine':{
            '& $box':{
              '& $numberBox':{
                borderRadius: '25px'
              }
            }
          }
        }
      }
    },
    '& $occupFooter':{
      borderRadius: '0 0 25px 25px',
      '& $tableLine':{
        '& $box':{
          '& $confirmButton':{
            borderRadius: '25px',
          }
        }
      }
    }
  }
};
